<template>
    <h1 class="text-left text-brand font-bold text-2xl py-3">Serviços</h1>
    <div
        @mouseleave="contractMenu"
        @mouseenter="expandMenu"
        ref="menuContainer"
        class="text-center w-full bg-white rounded-lg mt-2 pt-3 pb-3 border shadow-lg"
        :class="state.menuContainerClasses">
        <nav class="flex flex-wrap items-center justify-center">
            <a v-for="(item, index) in state.employeeMenu"
                :key=index
                :href="!item.external_url ? item.uuid_url : item.external_url"
                class="w-menu-icon h-menu-icon m-1 inline-table align-top text-brand consignado-icon text-center border-4 border-gray-300 rounded-xl relative hover:border-brand"
                :title="item.text"
                target="_blank"
            >
                <img class="rounded-xl z-1n" :src="item.icon_file || require('../../assets/images/no-image.png')"/>
                <div v-if="false" class="absolute left-0 bottom-1.5 w-full leading-3 block">
                    <span class="font-bold block text-sm leading-4">
                        {{ item.title }}
                    </span>
                </div>
            </a>
        </nav>
    </div>
    <span
        v-if="state.isHome"
        v-show="!state.isMenuExpanded"
        class="hidden xl:flex justify-center items-center w-full h-14 absolute text-center bottom-0 shadow-md rounded-b-lg bg-white cursor-pointer"
        @click="expandMenu"
    >
        <i class="fas fa-chevron-down text-gray-400 "></i>
    </span>

</template>

<script>
import { reactive, ref, inject } from 'vue'
import { useRoute } from 'vue-router'
import api from '@/services'

export default {

    setup () {

        const route = useRoute()
        const menuContainer = ref(null)
        const isHome = route.path == '/'

        let menuContainerClasses = ''
        if(isHome)
            menuContainerClasses = 'xl:absolute xl:h-service-menu xl:overflow-hidden'

        const globalState = inject('globalState')
        const state = reactive({
            employeeMenu: [],
            menuContainerClasses,
            isHome,
            isMenuExpanded: false
        })

        globalState.loadingTasks++
        api.menu.employeeMenu().then(menuItems => {
            state.employeeMenu = menuItems
            globalState.loadingTasks--
        })

        function expandMenu()
        {
            if(isHome)
            {
                state.isMenuExpanded = true
                menuContainer.value.classList.remove('xl:overflow-hidden')
                menuContainer.value.classList.remove('xl:h-service-menu')
                menuContainer.value.classList.add('pb-3')
                menuContainer.value.classList.add('z-10')
            }
        }

        function contractMenu()
        {
            if(isHome)
            {
                state.isMenuExpanded = false
                menuContainer.value.classList.add('xl:overflow-hidden')
                menuContainer.value.classList.add('xl:h-service-menu')
                menuContainer.value.classList.remove('pb-3')
                menuContainer.value.classList.remove('z-10')
            }
        }

        return {
            state,
            menuContainer,
            expandMenu,
            contractMenu
        }
    }
}
</script>

<style>

@layer utilities {

    .h-menu-icon {
        height: 85px;
    }

    .w-menu-icon {
        width: 85px;
    }

    .z-1n {
        z-index: -1;
    }

}

</style>
